import React, { useMemo } from 'react';

import type { ChannelType } from '@/modules/common/types/channel';

import { useSlideDimensions } from '../../../helpers/carousel';
import { getDummyList } from '@/modules/common/helpers/object';

import { Skeleton as SlideSkeleton } from '../Slide/Slide';

import styles from './CarouselSkeleton.module.scss';

type Props = {
  channel: ChannelType;
};

function CarouselSkeleton({ channel }: Props) {
  const dimensions = useSlideDimensions(channel.design, channel.size);

  const children = useMemo(
    () => getDummyList(Math.max(1, Math.ceil(window.innerWidth / (dimensions.width + dimensions.padding)))),
    [],
  );

  return (
    <div className={styles.Wrapper}>
      <div tabIndex={-1} role="button" className={styles.Content}>
        {children.map((key) => (
          <div
            key={key}
            className={styles.Slide}
            style={{
              width: dimensions.width,
            }}
          >
            <SlideSkeleton key={key} height={dimensions.height} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default CarouselSkeleton;
